<router-outlet></router-outlet>
<ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" size="medium" color="#1049A2" type="ball-clip-rotate-multiple" [fullScreen]="true"><p class="text-primary"> Cargando... </p></ngx-spinner>
